import { get } from 'axios'

export const getEngagementMatrix = (groupId = 'company') => {
  return get(`analytics/engagement-matrix/${groupId}`, {
    responseType: 'arraybuffer',
  })
}

export default {
  getEngagementMatrix,
}
